<template>
  <v-container grid-list-xl class="pa-5">
    <v-row wrap>
      <!-- Breadcrumb -->
      <v-col cols="12">
        <div class="d-flex align-center mb-4">
          <v-icon class="mr-2" style="cursor: pointer" @click="$router.back()">mdi-home</v-icon>
          <span class="body-2" style="cursor: pointer" @click="$router.back()">Paket Berlangganan</span>
          <v-icon small class="mx-2">mdi-chevron-right</v-icon>
          <span class="body-2 font-weight-bold">Riwayat Pesanan</span>
        </div>
      </v-col>

      <!-- Main Content -->
      <v-col cols="12">
        <m-card-list
          title="Riwayat Pesanan"
          label-cari="Cari Riwayat Pesanan"
          search
          refresh
          :items="items"
          :headers="headers"
          @search="
            (search) => {
              textSearch = search
              load()
            }
          "
          :page="page"
          @change:page="
            (pg) => {
              cp = pg
              load()
            }
          "
          @refresh="load()"
          footer
        >
          <template v-slot:items="{ item }">
            <tr v-if="$vuetify.breakpoint.smAndUp">
              <!-- Periode -->
              <td>
                <div class="py-2">
                  {{ formatPeriode(item.created_at, item.batas_bayar) }}
                </div>
              </td>

              <!-- Item Berlangganan -->
              <td>
                <div class="py-2">
                  <div class="font-weight-bold">{{ getJenisPesanan(item.k_jenis_pesanan) }}</div>
                  <div class="caption grey--text">{{ item.email }}</div>
                </div>
              </td>

              <!-- Total Bayar -->
              <td width="15%">
                <div class="font-weight-bold"> Rp {{ formatCurrency(item.total) }} </div>
              </td>

              <!-- Kode Bayar -->
              <td>
                <div>{{ item.kode || '-' }}</div>
              </td>

              <!-- Kode Aktivasi -->
              <td>
                <div>{{ getKodeAktivasi(item) || 'Belum Aktivasi' }}</div>
              </td>

              <!-- Status Bayar -->
              <td>
                <v-chip outlined small :color="getStatusColor(item)">
                  {{ getStatusText(item) }}
                </v-chip>
              </td>

              <!-- Faktur Pajak -->
              <td align="center">
                <v-btn
                  v-if="item.is_bayar === 0 && item.is_expired === 0"
                  small
                  color="primary"
                  depressed
                  @click="goToPembayaran(item)"
                  title="Bayar Sekarang"
                >
                  Lanjut Bayar
                </v-btn>
                <v-btn
                  v-else-if="item.is_request_faktur && item.file_faktur"
                  icon
                  small
                  color="primary"
                  @click="downloadFaktur(item.file_faktur)"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <v-btn v-else-if="item.is_request_faktur && !item.file_faktur" icon small color="grey" disabled>
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <span v-else class="grey--text caption">-</span>
              </td>
            </tr>

            <!-- Mobile View -->
            <tr v-else>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">Periode</div>
                <div class="v-data-table__mobile-row__cell">
                  {{ formatPeriode(item.created_at, item.batas_bayar) }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">Item Berlangganan</div>
                <div class="v-data-table__mobile-row__cell">
                  <div class="font-weight-bold">{{ getJenisPesanan(item.k_jenis_pesanan) }}</div>
                  <div class="caption grey--text">{{ item.email }}</div>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">Total Bayar</div>
                <div class="v-data-table__mobile-row__cell font-weight-bold"> Rp {{ formatCurrency(item.total) }} </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">Kode Bayar</div>
                <div class="v-data-table__mobile-row__cell">
                  {{ item.kode || '-' }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">Kode Aktivasi</div>
                <div class="v-data-table__mobile-row__cell">
                  <v-chip small :color="getKodeAktivasi(item) ? 'success' : 'grey'" text-color="white">
                    {{ getKodeAktivasi(item) || 'Belum Aktivasi' }}
                  </v-chip>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">Status Bayar</div>
                <div class="v-data-table__mobile-row__cell">
                  <v-chip small :color="getStatusColor(item)" text-color="white">
                    {{ getStatusText(item) }}
                  </v-chip>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">Aksi</div>
                <div class="v-data-table__mobile-row__cell">
                  <v-btn
                    v-if="item.is_bayar === 0 && item.is_expired === 0"
                    icon
                    small
                    color="primary"
                    @click="goToPembayaran(item)"
                    title="Bayar Sekarang"
                  >
                    Bayar
                  </v-btn>
                  <v-btn
                    v-else-if="item.is_request_faktur && item.file_faktur"
                    icon
                    small
                    color="primary"
                    @click="downloadFaktur(item.file_faktur)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <v-btn v-else-if="item.is_request_faktur && !item.file_faktur" icon small color="grey" disabled>
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <span v-else class="grey--text caption">-</span>
                </div>
              </td>
            </tr>
          </template>
        </m-card-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      items: [],
      page: null,
      cp: 1,
      textSearch: null,
      headers: [
        { text: 'Periode', value: 'created_at', align: 'left', sortable: true },
        { text: 'Item Berlangganan', value: 'nama_npwp', align: 'left', sortable: false },
        { text: 'Total Bayar', value: 'total', align: 'left', sortable: true },
        { text: 'Kode Bayar', value: 'kode_bayar', align: 'left', sortable: false },
        { text: 'Kode Aktivasi', value: 'kode_aktivasi', align: 'left', sortable: false },
        { text: 'Status Bayar', value: 'is_bayar', align: 'left', sortable: true },
        { text: 'Aksi', value: 'file_faktur', align: 'center', sortable: false },
      ],
    }
  },
  activated() {
    this.load()
  },
  methods: {
    load() {
      this.$store
        .dispatch('billing/getRiwayat', {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch,
          },
        })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data || []
        })
        .catch((e) => {
          console.error(e)
        })
    },
    formatPeriode(startDate, endDate) {
      if (!startDate || !endDate) return '-'
      const start = moment(startDate).format('DD-MM-YYYY')
      const end = moment(endDate).format('DD-MM-YYYY')
      return `${this.getDayName(startDate)}, ${start} - ${this.getDayName(endDate)}, ${end}`
    },
    getDayName(date) {
      const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
      return days[moment(date).day()]
    },
    formatCurrency(value) {
      if (!value) return '0'
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    getJenisPesanan(kode) {
      const jenis = {
        1: 'Berlangganan Baru',
        2: 'Perpanjangan',
        3: 'Tambah Kuota',
      }
      return jenis[kode] || '-'
    },
    getStatusText(status) {
      if (status.is_bayar === 1) return 'Sudah Bayar'
      if (status.is_bayar === 0 && status.is_expired === 1) return 'Kadaluarsa'
      return 'Menunggu Pembayaran'
    },
    getStatusColor(status) {
      if (status.is_bayar === 1) return 'success'
      if (status.is_bayar === 0 && status.is_expired === 1) return 'error'
      return 'warning'
    },
    downloadFaktur(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    getKodeAktivasi(item) {
      // Cek apakah ada aktivasi dan ambil token dari aktivasi pertama
      if (item.aktivasi && Object.keys(item.aktivasi).length) {
        return item.aktivasi.token
      }
      // Fallback ke kode_aktivasi jika ada
      return item.kode_aktivasi || null
    },
    goToPembayaran(data) {
      this.$router.push({
        name: "billing.pembayaran",
        params: {
          organisasi_id: this.organisasi_id,
          kode_pembayaran: data.kode
        }
      });
    },
  },
}
</script>
